import {useSearchParams} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {AccessDeniedBlock} from "@/pages/website/components/AccessDeniedBlock.tsx";

export const AccessDeniedPage = () => {
  const {user} = useCurrentUserContext();
  const [searchParams] = useSearchParams();
  const isOwnerRequired = searchParams.get("type") === "owner";

  return (
    <AccessDeniedBlock title="403 - Access Denied">
      <div>
        <div className="fw-bold fs-5">Access Denied</div>
        <div className="mt-2">
          {isOwnerRequired
            ? "In order to subscribe or modify your account we require the account owner to be logged in."
            : "Your user currently does not have the required permission level to access this feature."}
        </div>
        <div className="mt-2">
          Please contact your account owner{" "}
          {user?.account && (
            <div>
              <a className="text-black fw-semibold" href={`mailto:${user.account.primary_user_email}`}>
                {user.account.primary_user_name} ({user.account.primary_user_email})
              </a>
            </div>
          )}
          {isOwnerRequired ? "and have them login to proceed." : "to have them provision you the necessary access."}
        </div>
      </div>
    </AccessDeniedBlock>
  );
};
